// extracted by mini-css-extract-plugin
export var actionIcon = "_up-0";